import { useEffect, useRef } from 'react'

export function useInfiniteScroll(
  onReachEnd: () => void,
  enabled: boolean,
): React.RefObject<HTMLDivElement | null> {
  const ref = useRef<HTMLDivElement>(null)
  const handler = useRef(onReachEnd)
  handler.current = onReachEnd

  useEffect(() => {
    const el = ref.current
    if (el === null || !enabled) return

    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) handler.current()
      },
      { rootMargin: '400px' },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [enabled])

  return ref
}
